var map = {
	"./Oiltanking Logística Brasil.jpg": "7358",
	"./Oiltanking Logística Brasil_1.jpg": "94fa",
	"./Oiltanking Log┬░stica Brasil.jpg": "2117",
	"./Oiltanking Log┬░stica Brasil_1.jpg": "6ea4",
	"./Oiltanking_South-America_Argentina_Puerto-Rosales_Tanks_2009-03-04_1070341.jpg": "0bf4",
	"./gptw-latam-v2.jpg": "7ccb",
	"./image006.png": "d28ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09e7";